/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import {
    object, shape, string,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useUIDSeed } from 'react-uid';

const styles = () => ({
    cyoWrapper: {
        float: 'left',
        width: '120px',
        height: '250px',
        marginRight: '6px',
        textAlign: 'center',
        position: 'relative',
    },
    cyoImage: {
        width: '120px',
        height: '131px',
    },
    prodName: {
        height: '33px',
        overflow: 'hidden',
        fontSize: '13px',
        lineHeight: '1.3',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': '3',
        '-webkit-box-orient': 'vertical',
    },
    formControl: {
        margin: '0',
    },
});

const CYORadioItems = ({ component, classes, selectedBand }) => {
    if (!component) return null;
    const { name, image, legacyId } = component;
    const seed = useUIDSeed();
    return (
        <div className={classes.cyoWrapper} key={seed(component)}>
            <img src={`${image?.path}${image?.name}c.jpg`} alt={component.name} className={classes.cyoImage} />
            <Typography className={classes.prodName}>{ReactHtmlParser(name)}</Typography>
            <FormControlLabel className={classes.formControl} id={`select_${component.legacyId}`} value={legacyId} control={<Radio checked={selectedBand === component.legacyId} />} />
        </div>
    );
};

CYORadioItems.propTypes = {
    classes: object.isRequired,
    component: shape({
        name: string.isRequired,
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }),
        legacyId: string.isRequired,
    }).isRequired,
    selectedBand: string.isRequired,
};

export default withStyles(styles)(CYORadioItems);
